import styled from 'styled-components';

export const SectionTitle = styled.p`
  font-weight: bold;
  font-size: 1.2em;
  margin: 0 0 12px;
`;

export const SectionNote = styled.p`
  font-style: italic;
  margin: 3px 0 0;
`;
